import "./index.js"; import "./scroll_to_anchor.coffee"
